import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const generateDocument = (orderID, templateID) => {
  return api.get(
    `${URLS.generateDocument}?id=${orderID}&templateID=${templateID}`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getDocumentForTemplate = (orderID, templateID) => {
  return api.get(
    `${URLS.get_document}?id=${orderID}&templateID=${templateID}`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateDocument = (orderID, templateID, documentData) => {
  return api.put(
    `${URLS.update_document}?id=${orderID}&templateID=${templateID}`,
    documentData,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getClientDeliverables = (orderID) => {
  return api.get(URLS.getPreviewDeliverables, {
    params: {
      id: orderID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getDeliverablesTemplateName = (query, productId) => {
  return api.get(URLS.deliverables, {
    params: {
      ...(query && { query }),
      productId
    },
    headers: {
      needsToken: true
    }
  });
};
